(function () {
  var header = document.querySelector('.hdt-main-header');
  var form = header && header.querySelector('.hdt-header-search_form_short');
  var input = form && form.querySelector('.hdt-search_input');
  if (!header || !form || !input) return;

  function expand() {
    if (window.matchMedia && !window.matchMedia('(min-width: 1150px)').matches) return;
    header.classList.add('hdt-search-focused');
  }

  function collapse() {
    if (form.contains(document.activeElement)) return;
    header.classList.remove('hdt-search-focused');
  }

  input.addEventListener('focus', expand);
  input.addEventListener('click', expand);
  input.addEventListener('blur', function () { setTimeout(collapse, 150); });

  document.addEventListener('mousedown', function (e) {
    if (!form.contains(e.target)) {
      header.classList.remove('hdt-search-focused');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      input.blur();
      header.classList.remove('hdt-search-focused');
    }
  });
})();
